import { RouteObject } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

// Vendor Pages
import VendorDashboard from "@/pages/vendor/Dashboard";
import Products from "@/pages/vendor/Products";
import AddProduct from "@/pages/vendor/products/AddProduct";
import Orders from "@/pages/vendor/Orders";
import Customers from "@/pages/vendor/Customers";
import SalesAnalytics from "@/pages/vendor/analytics/SalesAnalytics";
import PerformanceAnalytics from "@/pages/vendor/analytics/PerformanceAnalytics";
import Notifications from "@/pages/vendor/Notifications";
import Settings from "@/pages/vendor/Settings";

const vendorRoutes: RouteObject[] = [
  {
    path: "/vendor",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><VendorDashboard /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/products",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><Products /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/products/add",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><AddProduct /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/orders",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><Orders /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/customers",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><Customers /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/analytics/sales",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><SalesAnalytics /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/analytics/performance",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><PerformanceAnalytics /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/notifications",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><Notifications /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/vendor/settings",
    element: (
      <ProtectedRoute allowedRoles={['vendor']}>
        <Layout><Settings /></Layout>
      </ProtectedRoute>
    ),
  },
];

export default vendorRoutes;